module.exports = __webpack_public_path__ + "static/media/header-1800.82f10d01.jpg";